import 'bootstrap';
import 'slick-carousel';

import Newsletter from '../components/newsletter/js/newsletter';
import footerNotification from '../components/footer/js/footer-notification';

// eslint-disable-next-line import/extensions
import { addCssClassToYoutubeIframe } from './helpers/helpers.js';

const $ = require('jquery');

const $root = $('html, body');

global.$ = $;

global.jQuery = $;

require('popper.js');

const defaultsCarouselOptions = {
	autoplay: true,
	infinite: true,
	lazyLoad: 'ondemand',
	slidesToShow: 6,
	slidesToScroll: 6,
	speed: 400,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 4,
				slidesToScroll: 4,
			},
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
			},
		},
	],
};

document.addEventListener('DOMContentLoaded', () => {
	const showCarouselSpecificOptions = {
		autoplay: false,
		infinite: false,
		lazyLoad: 'progressive',
		responsive: [
			{
				breakpoint: 1081,
				settings: {
					arrows: false,
				},
			},
			{
				breakpoint: 992,
				settings: {
					arrows: false,
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
			{
				breakpoint: 576,
				settings: {
					arrows: false,
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
		],
	};

	const showCarouselOptions = { ...defaultsCarouselOptions, ...showCarouselSpecificOptions };

	// Initialize custom shows carousels
	$('.custom-shows-carousel .carousel-items')
		.slick(showCarouselOptions);
	$('.shows-carousel--items').slick(showCarouselOptions);

	// Initialize other carousels excluding custom shows carousels
	$('.carousel-items')
		.not('.custom-shows-carousel .carousel-items')
		.slick(defaultsCarouselOptions);

	const rankedCarouselSpecificOptions = {
		slidesToShow: 5,
		slidesToScroll: 5,
	};

	const rankedCarouselOptions = {
		...defaultsCarouselOptions,
		...showCarouselSpecificOptions,
		...rankedCarouselSpecificOptions,
	};

	$('.ranked-shows-carousel__items').slick(rankedCarouselOptions);

	const videoCarouselSpecificOptions = {
		autoplay: false,
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 4,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
		],
	};

	const videoCarouselOptions = { ...defaultsCarouselOptions, ...videoCarouselSpecificOptions };

	$('.video-carousel-items').slick(videoCarouselOptions);

	// featured rotator on homepage
	document.querySelectorAll('.featured-rotator').forEach((rotator) => {
		const slider = rotator.querySelectorAll('.featured-rotator-slider');
		const slides = Array.from(rotator.querySelectorAll('.featured-rotator-slide'));
		const prevBtn = Array.from(rotator.querySelectorAll('.rotator-prev-btn'));
		const nextBtn = Array.from(rotator.querySelectorAll('.rotator-next-btn'));
		const arrowsContainer = rotator.querySelector('.featured-rotator-controls');
		const dotsContainer = rotator.querySelector('.featured-rotator-controls-dots');
		const autoRotation = slider ? slider[0].dataset.autoRotation : '';

		let interval;
		let slideIndex = 0;

		slides.forEach((_, i) => {
			const dot = document.createElement('button');
			dot.classList.add('dot-btn');
			if (i === 0) dot.classList.add('active');
			dotsContainer.appendChild(dot);
		});

		const dots = Array.from(dotsContainer.querySelectorAll('.dot-btn'));
		// for initial page load to display image on autorotate on
		if (slider[0]) {
			const slideWidth = slider[0].clientWidth;
			slider[0].style.transform = `translateX(-${slideIndex * slideWidth}px)`;
		}

		// update slider dots
		function updateDots() {
			dots.forEach((dot, i) => {
				dot.classList.toggle('active', i === slideIndex);
			});
		}

		function updateSlider() {
			if (!slider[0]) return;
			const slideWidth = slider[0].clientWidth;
			slider[0].style.transform = `translateX(-${slideWidth * slideIndex}px)`;
		}

		// Adding margin bottom to dots as per the content height
		function updateDotsContainerMargin() {
			const currentSliderContent = document.querySelector('.featured-rotator-slider-content');
			const slideContentHeight = currentSliderContent ? currentSliderContent.marginBottom : 0;
			const containerMarginBottom = 50;
			if (arrowsContainer) {
				arrowsContainer.style.marginBottom = `${slideContentHeight + containerMarginBottom}`;
			}
			if (dotsContainer) {
				dotsContainer.style.marginBottom = `${slideContentHeight + containerMarginBottom}`;
			}
		}

		// on dots click change the slide
		if (dotsContainer) {
			dotsContainer.addEventListener('click', (event) => {
				const clickedDot = event.target;
				if (clickedDot.classList.contains('dot-btn')) {
					slideIndex = Array.from(dotsContainer.children).indexOf(clickedDot);
					updateSlider();
					updateDots();
					updateDotsContainerMargin();
				}
			});
		}

		function nextAutoSlide() {
			slideIndex = (slideIndex + 1) % slides.length;
			updateSlider();
			updateDots();
		}

		function startAutoRotate() {
			interval = setInterval(nextAutoSlide, 6000);
		}

		function stopAutoRotate() {
			clearInterval(interval);
		}

		// check if autoRotation is active or not.
		// settings on the featured Rotator component: Auto-rotate Rotator Banner Toggle settings
		if (slides.length > 1 && autoRotation === '1') {
			// stop auto rotation on mouse entre and start as it leaves
			slider[0].addEventListener('mouseenter', () => {
				stopAutoRotate();
			});

			slider[0].addEventListener('mouseleave', () => {
				startAutoRotate();
			});
		}

		// prev btn click
		if (prevBtn) {
			prevBtn.forEach((prevbtn) => {
				prevbtn.addEventListener('click', () => {
					// get prev slide
					slideIndex = (slideIndex - 1 + slides.length) % slides.length;
					updateSlider();
					updateDots();
					updateDotsContainerMargin();
					stopAutoRotate();
				});
			});
		}

		// next btn click
		if (nextBtn) {
			nextBtn.forEach((nextbtn) => {
				nextbtn.addEventListener('click', () => {
					// get next slide
					slideIndex = (slideIndex + 1) % slides.length;
					updateSlider();
					updateDots();
					updateDotsContainerMargin();
					stopAutoRotate();
				});
			});
		}

		// resize slider to fit in the screen when checking media on manual strech and compress
		function resizeSlider() {
			updateSlider();
			updateDots();
			updateDotsContainerMargin();
		}

		window.addEventListener('resize', resizeSlider);
		window.addEventListener('load', updateDotsContainerMargin);

		updateSlider();
	});

	// smooth scrolling, disabled for accordion links
	$('a[href*="#"]:not([data-toggle]):not([href*="#accordion-informational-section"])').on('click', function smoothScroll() {
		const href = $.attr(this, 'href');
		const hashIndex = href.indexOf('#');
		if (hashIndex === -1) return;

		const hash = href.slice(hashIndex);
		const $target = $(hash);

		// If target does not exist, do nothing
		if (!$target.length) {
			return;
		}

		// Collapse the navbar if it's open
		if ($('#main_collapsable_nav').hasClass('show')) {
			$('#main_collapsable_nav').collapse('hide');
			$('body').removeClass('ham-open');
		}

		$root.animate({
			scrollTop: $target.offset().top,
		}, 500, () => {
			window.location.hash = hash;
		});
	});

	// Evidon cookie consent menu link handler
	document.querySelectorAll('.evidon-consent-menu-link').forEach((el) => {
		el.addEventListener('click', (e) => {
			e.preventDefault();

			const internalButton = document.getElementById('_evh-link');
			if (internalButton) {
				internalButton.click();
			}
		});
	});

	// Adds and removes 'zoomed' class to related-items__thumbnail when hover the related-items__title
	document.querySelectorAll('.related-items__title a').forEach(
		(title) => {
			title.addEventListener(
				'mouseenter',
				function addZoomedClass() {
					this.closest('.related-items__grid-item')
						.querySelector('.related-items__thumbnail')
						.classList.add('zoomed');
				},
			);
			title.addEventListener(
				'mouseleave',
				function removeZoomedClass() {
					this.closest('.related-items__grid-item')
						.querySelector('.related-items__thumbnail')
						.classList.remove('zoomed');
				},
			);
		},
	);

	// Handle accordion link clicks
	$('a[href*="#accordion-informational-section"]:not(.accordion-title)').on('click', function handleAccordionClick(e) {
		e.preventDefault();
		e.stopPropagation();

		const href = $(this).attr('href');
		const hash = href.includes('#') ? href.substring(href.indexOf('#')) : href;
		const $target = $(hash);

		// Collapse the navbar if it's open
		if ($('#main_collapsable_nav').hasClass('show')) {
			$('#main_collapsable_nav').collapse('hide');
			$('body').removeClass('ham-open');
		}

		// If accordion doesn't exist on this page, redirect to home with hash
		if (!$target.length) {
			window.location.href = `/${hash}`;
			return;
		}

		$('html, body').stop(true, false);
		const scrollPosition = $(window).scrollTop();

		// Close all other accordion sections first
		$('.accordion-informational-section.show').not($target).collapse('hide');

		// Open the target accordion if it's not already open
		if (!$target.hasClass('show')) {
			$target.collapse('show');
		}

		$(window).scrollTop(scrollPosition);

		// Smooth scroll after accordion opens
		setTimeout(() => {
			$('html, body').animate({
				scrollTop: $target.closest('.accordion-wrapper').offset().top - 95,
			}, 500);
		}, 350);
	});

	// Handle direct accordion URL hash on page load
	if (window.location.hash && window.location.hash.indexOf('#accordion-informational-section') === 0) {
		const $target = $(window.location.hash);

		if ($target.length) {
			// Prevent initial jump
			const scrollPosition = $(window).scrollTop();

			// Open the accordion
			if (!$target.hasClass('show')) {
				$target.collapse('show');
			}

			// Scroll position
			$(window).scrollTop(scrollPosition);

			// Smooth scroll
			setTimeout(() => {
				$('html, body').animate({
					scrollTop: $target.closest('.accordion-wrapper').offset().top - 95,
				}, 500);
			}, 500);
		}
	}
});

// Define learnMoreText globally (outside of any function or block)
const learnMoreText = 'LEARN MORE';

// PROVIDERS START -- Replace Learn More text with the Alt text of the image.
const changeLearnMoreButtonText = (item, index, setNames) => {
	const link = setNames[index];
	const isMobile = $(window).width() < 768;

	if (isMobile) {
		link.innerText = item.getAttribute('alt');
	} else if (link.innerText !== learnMoreText) {
		// Update only if the current content is not the default learnMoreText
		link.innerText = learnMoreText;
	}
};

const updateLearnMoreButtonText = () => {
	const sectionProviders = Array.from(document.querySelectorAll('#section-providers, #section-subscribe-now')).filter(Boolean);

	if (sectionProviders !== null) {
		sectionProviders.forEach((section) => {
			const images = Array.from(section.getElementsByTagName('img'))
				.filter((link) => !link.classList.contains('ici_additional_header_img'));
			const links = Array.from(section.getElementsByTagName('a'))
				.filter((link) => !link.classList.contains('brand_cta_button'));

			images.forEach((item, index) => {
				changeLearnMoreButtonText(item, index, links);
			});
		});
	}
};

// Trigger the function on window resize or load
$(window).on('resize load', updateLearnMoreButtonText);
// PROVIDERS END

// Change the background colour for H2 to match the section background colour
const sectionBg = document.getElementById('section-providers');
const sectionBgColour = sectionBg ? getComputedStyle(sectionBg).backgroundColor : '';
$('#section-providers .info-card-main-title').css('background', sectionBgColour);

// Initialize the newsletter
Newsletter();

// Initializing footer notification
footerNotification();

// Using helper class to add css class to Youtube video iframe
document.addEventListener('DOMContentLoaded', addCssClassToYoutubeIframe);
